var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.047 42.062"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.249 21.026l15.915-15.9A3.006 3.006 0 0018.907.881L.876 18.9a3 3 0 00-.088 4.145l18.104 18.141a3.006 3.006 0 104.257-4.245z"
  })));
}
export default SvgArrowPrev;